import React from "react";

// ─── Card definitions ────────────────────────────────────────────────────────
// accent = the left-border color strip (matches screenshot colors exactly)
const CARDS = [
  { key: "total", label: "OPEN", accent: "#2563eb" }, // blue
  { key: "new", label: "NEW", accent: "#2563eb" }, // blue
  { key: "inProgress", label: "IN PROGRESS", accent: "#f97316" }, // orange
  { key: "resolved", label: "RESOLVED", accent: "#10b981" }, // green
  { key: "rejected", label: "REJECTED", accent: "#a855f7" }, // purple
  { key: "highPriority", label: "HIGH PRIORITY", accent: "#ef4444" }, // red
];

const TicketStatsCards = ({ tickets = [] }) => {
  // ── Dynamic counts — replace values here if your data shape differs ────────
  const counts = {
    total: tickets.filter(t => t.status === "New" || t.status === "In Progress").length,
    new: tickets.filter(t => t.status === "New").length,
    inProgress: tickets.filter(t => t.status === "In Progress").length,
    resolved: tickets.filter(t => t.status === "Resolved").length,
    rejected: tickets.filter(t => t.status === "Rejected").length,
    highPriority: tickets.filter(t => t.priority === "High" && !["Closed", "Rejected"].includes(t.status)).length,
  };
  // ──────────────────────────────────────────────────────────────────────────

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: 14,
        marginBottom: 24,
      }}
    >
      {CARDS.map(({ key, label, accent }) => (
        <div
          key={key}
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            borderLeft: `4px solid ${accent}`,   // left vertical colored accent
            padding: "16px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 6,
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          {/* Label — uppercase, small, gray */}
          <span
            style={{
              fontSize: 11,
              fontWeight: 500,
              color: "#9ca3af",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
            }}
          >
            {label}
          </span>

          {/* Count — large, bold, near-black */}
          <span
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: "#111827",
              lineHeight: 1.1,
              fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
            }}
          >
            {counts[key]}          </span>
        </div>
      ))}
    </div>
  );
};

export default TicketStatsCards;